import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { Blogpostdetail } from './blogpostdetail.page';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
export const routes: Routes = [
    { path: 'blogpostdetail/:id/:bid', component: Blogpostdetail },
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes),
        NgbModule
    ],
    declarations: [
        Blogpostdetail
    ],
})
export class BlogpostdetailModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/blogpostdetail/blogpostdetail.module.ts